import { render, staticRenderFns } from "./ItemHistory.vue?vue&type=template&id=8d2041e2&"
import script from "./ItemHistory.vue?vue&type=script&lang=js&"
export * from "./ItemHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports